import React from 'react'
import styled from 'styled-components'
import Card from '../../components/Card'
import { pxToRem } from '../../utils'

const Wrapper = styled(Card)`
  margin-top: ${pxToRem(10)};
  margin-right: ${pxToRem(15)};
  max-width: ${pxToRem(355)};
  min-width: ${pxToRem(300)};
  min-height: ${pxToRem(500)}
  flex: 1;
  flex-shrink: 0;
  scroll-snap-align: center;
  position: relative;

  @media only screen and (max-width: 550px) {
    width: calc(80vw - 1.875rem);
    min-width: unset;
    flex: none;
  }
`

class Cabinet extends React.PureComponent {
  render() {
    const {
      title,
      editPermission,
      closePermission,
      closeButtonAction,
      editButtonAction,
      exportButtonAction,
      qrCodePrintButtonAction
    } = this.props
    return (
      <Wrapper
        title={title}
        editPermission={editPermission}
        closePermission={closePermission}
        closeButtonAction={closeButtonAction}
        editButtonAction={editButtonAction}
        exportButtonAction={exportButtonAction}
        qrCodePrintButtonAction={qrCodePrintButtonAction}
      >
        {' '}
        {this.props.children}
      </Wrapper>
    )
  }
}

export default Cabinet



// WEBPACK FOOTER //
// ./src/containers/IncompatibilityAnalysis/Cabinet.js